import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import { pageDetailListTable as tableDef } from "../../config/grid-column-defs";
import {
  getPageDetailList,
  insertPageDetail,
  updatePageDetail,
} from "../../api/column";
import AddPageDetailColumns from "./add.page.detail.columns";
import useErrorHandler from "../../hooks/useErrorHandler";
const emptyData = {
  viewname: "",
  colname: [],
  labelname: [],
  pagename: "",
  secname: "",
};
export default function PageDetailColumns() {
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const dialogAction = useSelector((state) => state.dialog);
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addUpdate, setAddUpdate] = useState("");
  const [formData, setFormData] = useState(emptyData);
  const [checkBlankLabel, setCheckBlankLable] = useState([]);
  const [id, setId] = useState("");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    snackbar.hide();
  };
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  let obj = tableDef.find((o) => o.headerName === "Action");
  addAdditionalColumn(obj, dispatch);
  //get table data//

  async function getPageListTableData(limit, offset) {
    try {
      const { data } = await getPageDetailList(user?.token, {
        limit,
        offset,
      });
      return {
        rows: data.data.pageDetails,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      snackbar.showError(error);
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  const handleFormCreate = async (newData) => {
    setLoading(true);
    newData.labelname = removeIdFromString(formData.labelname);
    newData.colname = removeIdFromString(formData.colname);
    const combineData = { ...newData };

    if (Array.isArray(newData.colname) && Array.isArray(newData.labelname)) {
      newData.colname = removeIdFromString(
        convertArrayToString([...new Set(newData.colname)])
      );
      newData.labelname = removeIdFromString(
        convertArrayToString([...new Set(newData.labelname)])
      );
    }
    console.log("blank--", checkBlankLabel);
    const hasBlankLabel = checkBlankLabelName(checkBlankLabel);
    if (hasBlankLabel) {
      snackbar.showError("Found a blank label name!");
      setLoading(false);
      return;
    } else if (!checkBlankLabel.length) {
      snackbar.showError("select the column names");
      setLoading(false);
      return;
    }
    if (addUpdate === "ADD") {
      try {
        // snackbar.showSuccess("Please wait it will take time.");
        const { data } = await insertPageDetail(user.token, combineData);
        snackbar.showSuccess(data.msg);
        setLoading(false);
        setOpen(false);
        setFormData(emptyData);
        refreshTable();
      } catch (error) {
        setOpen(false);
        snackbar.showError(error);
      }
    } else {
      try {
        // snackbar.showSuccess("Please wait it will take time.");
        const { data } = await updatePageDetail(user.token, id, newData);
        snackbar.showSuccess(data.msg);
        setLoading(false);
        setOpen(false);
        setFormData(emptyData);
        refreshTable();
      } catch (error) {
        setOpen(false);
        snackbar.showError(error);
      }
    }
  };
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DIALOG":
        dispatch({ type: "" });
        const colArray = convertStringToArray(dialogAction.data.colname);
        const labelArray = convertStringToArray(dialogAction.data.labelname);
        // console.log("dialog--", resultArray);
        // dialogAction.data.colname = resultArray;

        setAddUpdate("UPDATE");
        setFormData({
          viewname: dialogAction.data.viewname,
          colname: colArray,
          labelname: labelArray,
          pagename: dialogAction.data.pagename,
          secname: dialogAction.data.secname,
        });
        setId(dialogAction.data.id);
        setOpen(true);

        break;

      default:
        break;
    }
  }, [dialogAction]);
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          Page Detail List
        </Typography>
        <Button
          className="backBtn"
          onClick={() => {
            setFormData(emptyData);
            setOpen(true);
            setAddUpdate("ADD");
          }}
        >
          Add Page Column
        </Button>
      </Box>

      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getPageListTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </Paper>
      <AddPageDetailColumns
        open={open}
        id={id}
        loading={loading}
        setOpen={setOpen}
        formData={formData}
        setFormData={setFormData}
        setCheckBlankLable={setCheckBlankLable}
        addUpdate={addUpdate}
        handleFormCreate={handleFormCreate}
      />
      <Snackbar open={loading} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={"info"} sx={{ width: "100%" }}>
          Please wait untill the changes are getting pushed.
        </Alert>
      </Snackbar>
    </>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      maxWidth: 86,
      cellRendererFramework: (params) => (
        <Box>
          <Button
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DIALOG", data: params.data });
            }}
          >
            <EditOutlinedIcon />
          </Button>
        </Box>
      ),
    });
  }
}
function convertStringToArray(str) {
  if (typeof str === "string") {
    return str.split(",");
  } else {
    // console.log("str====", str);
    return [];
  }
}
function convertArrayToString(arr) {
  return arr.join(",");
}
function removeIdFromString(str) {
  if (typeof str === "string") {
    const updatedString = str.replace(/(^|,)id(,|$)/g, ",");
    return updatedString.replace(/^,|,$/g, ""); // Remove leading or trailing commas, if any
  } else {
    // console.log("Invalid input: str must be a string.");
    return str;
  }
}
function checkBlankLabelName(arr) {
  return arr.some(
    (obj) => !obj.hasOwnProperty("label_name") || obj.label_name.trim() === ""
  );
}
